import config from 'config';

import { addAvgReviewFilterSetting } from './addAvgReviewFilterSetting';
import { addCategoryFilterSetting } from './addCategoryFilterSetting';
import { sortFilterSettingItems } from './sortFilterSettingItems';
import { getLabelSortedInitialAggregations } from './useLabels';

export function getFilterSettings({ aggregations, region, tld, gender }) {
  if (!aggregations?.length) {
    return [];
  }

  const showReviewFilter = config.get('public.brand.showReviewFilter');

  let sortedAggregations = getLabelSortedInitialAggregations(
    aggregations,
    region,
    tld,
    gender
  );

  sortedAggregations = sortedAggregations
    ? addCategoryFilterSetting(sortedAggregations)
    : undefined;

  let filterSettings = showReviewFilter
    ? addAvgReviewFilterSetting(sortedAggregations)
    : sortedAggregations;

  filterSettings = sortFilterSettingItems(
    filterSettings,
    'size_shoes',
    (a, b) => (parseFloat(a.value) > parseFloat(b.value) ? 1 : -1)
  );

  return filterSettings;
}
